import {Possessed} from "../Possessed";
import {PossessedGameAssets} from "../PossessedGameAssets";
import {SpineGSAPWrapper } from "../animation/SpineGSAPWrapper";
import {PossessedSymbol, PossessedSymbolCreateArgs} from './PossessedSymbol';
import {gsap} from "gsap"

export class PossessedInfectiousSymbol extends PossessedSymbol {

    private anim:PIXI.spine.Spine;

    constructor(args:PossessedSymbolCreateArgs) {
        super(args);
        
        this.anim = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset("spine/Infectious.json"));
        this.anim.visible = false;
        this.anim.position.y += 2;
        this.addChild(this.anim);
    }

    getLandAnimation(): gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                SpineGSAPWrapper.resetSpineState(this.anim);
            })
            .add(() => {
                Possessed.soundPlayer.playSoundWithDavidPanning("xwaysInfLand", this.reelID);
            })
            .add(SpineGSAPWrapper.createTimeline(this.anim, 0, "landing", 0), "<")
            .add(() => {
                this.anim.state.setAnimation(0, "activate", true);
            })
    }
}